import { IFindParameter, IResult } from '@/types/map';
import {
    boundingExtent,
    containsExtent,
    getCenter
} from 'ol/extent';
import Overlay from 'ol/Overlay.js';
import VectorLayer from 'ol/layer/Vector.js';
import { Geometry } from 'ol/geom';
import { Vector } from 'ol/source';
import HighFeauture2D from '../../Overlays/openlayers/HighFeature2D';


export class FindFeatureOpenlayers {
    private static instances: Map<string, any>;
    private map!: any;
    private findLayer: VectorLayer<Vector<Geometry>> | undefined;
    private constructor(map: any) {
        this.map = map;
    };
    
    public static getInstance(map: any){
        let id = map.getTarget();
        console.log(id);
        if (!FindFeatureOpenlayers.instances) {
            FindFeatureOpenlayers.instances = new Map();
        }
        let intance = FindFeatureOpenlayers.instances.get(id);
        if (!intance) {
          intance = new FindFeatureOpenlayers(map);
          FindFeatureOpenlayers.instances.set(id, intance);
        }
        return intance;
    }
    private async createOverlayLayer() {
        this.findLayer = new VectorLayer();
        this.map.addLayer(this.findLayer);
    }
    // 查找图层元素
    public async findLayerFeature(params: IFindParameter): Promise<IResult> {
        if (!this.findLayer) {//创建图层
            await this.createOverlayLayer();
        } else {//清除图层要素
            this.findLayer.getSource()?.clear();
        };
        let allLayers = this.map.getAllLayers();
        let results: any = [];
        let points: any = [];
        let centerResult = params.centerResult !== false;
        const noJump = params.noJump || false;

        allLayers.forEach((layer: any) =>{
            if (layer.get("label") == params.layerName){
                console.log(layer.get("label"));
                console.log(params.layerName);
                if (layer.get("cluster")){//聚合图层
                    console.log("聚合图层");
                    layer.getSource().forEachFeature((item: any) =>{
                        item.values_.features.forEach((feature: any) => {
                            let id = feature.getProperties().markId;
                            let fields = feature.getProperties().fields;
                            if (params.ids.indexOf(id) != -1){
                                results.push(feature);
                                let coor = [fields.crossLongitude, fields.crossLatitude];
                                points.push(coor);
                            };
                        });
                    });
                }else {//非聚合图层
                    console.log("非聚合图层");
                    layer.getSource().getFeatures().forEach((feature: { getProperties: () => any; }) =>{
                        let id = feature.getProperties().markId;
                        let fields = feature.getProperties().fields;
                        if (params.ids.indexOf(id) != -1){
                            results.push(feature);
                            let coor = [fields.crossLongitude, fields.crossLatitude];
                            points.push(coor);
                        };
                    });
                }
            }

        });
        // 将查找结果点位显示到地图中间并跳跃
        return new Promise<IResult>(async (resolve, reject) => {
            // 显示 撒点和线 的查找结果到地图中心
            if (results.length > 0 && centerResult) {
                console.log(results);
                this.zoomAndCenter(points, params);
                this.startJumpPoint(results, params);
            } 
            else if (results?.length > 0) {
                //不显示到地图中心，则直接跳跃结果点位
                if (!noJump) {
                    this.startJumpPoint(results, params);
                };
            };
            // resolve({
            //     status: 0,
            //     message: "ok",
            //     result: results,
            // });
            // return;
        });
        return { message: "", status: 0, result: {} };
      }


    // 地图中心点、层级设置
    public zoomAndCenter(points: any, params: IFindParameter) {
        let extent = boundingExtent(points);
        let cuVisibleExtent = this.map.getView().calculateExtent(this.map.getSize());
        if (containsExtent(cuVisibleExtent, extent)){//在可视范围内,直接修改中心点
            this.map.getView().setCenter(getCenter(extent));
        }else {//不在可视范围内,将可视区域缩放到所有点的边界
            this.map.getView().fit(extent);
        };
        let zoom = params.level || 10;
        this.map.getView().setZoom(Math.max(this.map.getView().getZoom(), zoom));
    };
    // 点跳跃
    private async startJumpPoint(graphics: any[], params: IFindParameter) {
        let high = HighFeauture2D.getInstance(this.map);
        high.startup(graphics, params);
    }
}